import { createContext, useContext, useState } from "react";

export const CarContext = createContext(undefined);

export const useCarContext = () => {
  const context = useContext(CarContext);

  if (!context) {
    throw new Error("Missing CarProvider.");
  }

  return context;
};

export const CarProvider = ({ children }) => {
  const [selectedCar, setSelectedCar] = useState(undefined);

  return (
    <CarContext.Provider
      value={{
        selectedCar,
        setSelectedCar,
      }}
    >
      {children}
    </CarContext.Provider>
  );
};

export const withCarProvider = (WrappedComponent) => {
  return function WithCarProvider(props) {
    return (
      <CarProvider>
        <WrappedComponent {...props} />
      </CarProvider>
    );
  };
};
